/**
 * API returns establishment/warehouse as PK integers plus *_data objects.
 * UI expects nested { id, name } objects.
 */
export function normalizePosSyncRecord(record) {
    if (!record) {
        return record;
    }
    const next = { ...record };
    if (typeof next.establishment === 'number') {
        next.establishment = next.establishment_data ?? { id: next.establishment };
    }
    if (typeof next.warehouse === 'number') {
        next.warehouse = next.warehouse_data ?? { id: next.warehouse };
    } else if (next.warehouse == null && next.warehouse_data) {
        next.warehouse = next.warehouse_data;
    }
    return next;
}

export function getPosSyncEstablishmentId(record) {
    if (!record) {
        return null;
    }
    if (typeof record.establishment === 'number') {
        return record.establishment;
    }
    return record.establishment?.id ?? record.establishment_data?.id ?? null;
}

export function getPosSyncWarehouseId(record) {
    if (!record) {
        return null;
    }
    if (typeof record.warehouse === 'number') {
        return record.warehouse;
    }
    return record.warehouse?.id ?? record.warehouse_data?.id ?? null;
}
